<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <span class="text-blue-400 items-center justify-center fas fa-route">
                </span>
            </div>
        </template>
        <div>
            <ui-input label="Send to" v-model="to"
                      placeholder="Email address/phone number (multiple separated with commas)..."
                      class="xl:col-span-12"
                      @input="error = false"
                      @focus=""
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="busy" @click="send"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {uuid} from "../../../utils";
import UiTextarea from "../../ui/UiTextarea.vue";

export default {
    components: {UiTextarea, UiButtonNew, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Send Application for Payment'
        },
        button: {
            type: String,
            default: 'Send Application for Payment'
        },
        name: '',
        contacts: {},
        applicationForPayment: Object,
    },
    data() {
        return {
            to: '',
            busy: false,
            error: false,
        }
    },
    methods: {
        contactSelected(e) {
            this.form.to = e.to;
        },
        async send() {
            this.busy = true;
            let id = uuid();
            let response = await this.applicationForPayment.send({to: this.to})
            this.busy = false;
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Invalid email')) {
                    this.error = 'ERROR: Cannot determine how to handle "' + this.to + '" - is this a valid email address or phone number?'
                    return
                }
            } else {
                this.to = '';
            }
            await this.handle(id, this)
        },
    }
}
</script>
